import React, { useEffect, useState } from 'react'
import { Table, Icon, Pagination } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import Proptypes from 'prop-types'
import Swal from 'sweetalert2'
import { DataGrid } from '@mui/x-data-grid'
import {
  GetCustomerDevices,
  GetCustomerDevicesWithSearch,
} from '../../../services/asset'
import generateRows from './generateRows'
import './devicesTable.css'

const DevicesTable = ({
  devices,
  size,
  pagesCount,
  customerId,
  search,
  activePage,
  setActivePage,
}) => {
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const [deviceList, setDeviceList] = useState([])
  const [noPages, setNoPages] = useState(0)

  useEffect(() => {
    setDeviceList(devices)
    console.log('devicesss: ', devices)
  }, [devices])

  useEffect(() => {
    setNoPages(pagesCount)
  }, [pagesCount])

  useEffect(() => {
    setActivePage(activePage)
  }, [activePage])

  const handlePageChange = async (e, data) => {
    const page = data.activePage - 1
    console.log('here')
    Swal.showLoading()
    const product = await localStorage.getItem('product')
    let res = {}
    if (search !== '') {
      res = await GetCustomerDevicesWithSearch(
        userEmail,
        product,
        page,
        size,
        customerId,
        search,
      )
    } else {
      res = await GetCustomerDevices(userEmail, product, page, size, customerId)
    }
    Swal.close()
    setDeviceList(generateRows(res.data))
    setActivePage(data.activePage)
    setNoPages(res['no of pages'])
  }

  const handleClasses = (params) => {
    const deviceStatus = params.row.status
    if (deviceStatus === 'OFFLINE' || deviceStatus === 'UNASSIGNED')
      return 'red'
    if (
      deviceStatus === 'CONFIGURED' ||
      deviceStatus === 'PROVISIONED' ||
      deviceStatus === 'ASSIGNED'
    )
      return 'blue'
    if (deviceStatus === 'CONNECTED') return 'yellow'
    if (deviceStatus === 'INSTALLED') return 'green'
    if (deviceStatus === 'INSTALLED') return 'green'

    return ''
  }

  const columns = [
    { width: 150, field: 'deviceId', headerName: 'Device Id' },
    { width: 160, field: 'name', headerName: 'Device Name' },
    { width: 154, field: 'type', headerName: 'Device Type' },
    {
      width: 165,
      field: 'status',
      headerName: 'Device Status',
      cellClassName: handleClasses,
    },
    { width: 201, field: 'date', headerName: 'Last Status Update' },
    { width: 271, field: 'warranty', headerName: 'Warranty Date' },
  ]

  return (
    <>
      <div style={{ height: deviceList.length > 0 ? '578px' : '100px' }}>
        <DataGrid
          columns={columns}
          rows={deviceList}
          pagination={false}
          hideFooter
          className="deviceList"
        />
      </div>
      {deviceList.length > 0 && (
        <Table.Footer
          style={{ textAlign: 'center', border: 'none' }}
          colSpan={2}
        >
          <Pagination
            activePage={activePage}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={noPages}
            onPageChange={(e, data) => handlePageChange(e, data)}
          />
        </Table.Footer>
      )}
    </>
  )
}

DevicesTable.propTypes = {
  devices: Proptypes.array,
  size: Proptypes.number,
  pagesCount: Proptypes.number,
  customerId: Proptypes.string,
  search: Proptypes.string,
  activePage: Proptypes.number,
  setActivePage: Proptypes.func,
}

export default DevicesTable
